import script from "./Ecp.vue?vue&type=script&setup=true&lang=js"
export * from "./Ecp.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__